import { render, staticRenderFns } from "./CardiolineRichiesteListComponent.vue?vue&type=template&id=52b56312&scoped=true"
import script from "./CardiolineRichiesteListComponent.vue?vue&type=script&lang=js"
export * from "./CardiolineRichiesteListComponent.vue?vue&type=script&lang=js"
import style0 from "./CardiolineRichiesteListComponent.vue?vue&type=style&index=0&id=52b56312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b56312",
  null
  
)

export default component.exports